export default __webpack_public_path__ + "static/nexgen-data-management-e89e5fbfdd22aeb60a0a1cd298e267e3.webp";